import React from 'react'

import ReactDOM from 'react-dom/client'
import ReactGA from 'react-ga4'
import TagManager from 'react-gtm-module'

import App from './App'
import { env } from './configs/env.config'

if (env.GOOGLE_GTAG && env.GOOGLE_GTM) {
  ReactGA.initialize(env.GOOGLE_GTAG, { gaOptions: { transport: 'beacon' } })
  TagManager.initialize({ gtmId: env.GOOGLE_GTM })
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
